<template>
    <div v-html="'Order'"/>
</template>

<script>
export default { name: "Order" };
</script>